import { render, staticRenderFns } from "./qna.vue?vue&type=template&id=ce799bae&"
import script from "./qna.vue?vue&type=script&lang=js&"
export * from "./qna.vue?vue&type=script&lang=js&"
import style0 from "./qna.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports